import { filter, flow, get, includes } from 'lodash/fp';

import uniqueContentWithDraftPrecedence from '../../src/client/cms/utils/unique-content-with-draft-precedence';
import type { BannersQuery } from '../../src/client/types/__codegen__/sanity/graphql';

// https://ahm.sanity.studio/structure/banner
export const HOME_PAGE_BANNER_IDENTIFIERS = {
  DEFAULT: 'home-default',
  DIVERSIFIED: 'home-diversified',
};

const filteredValues = Object.values(HOME_PAGE_BANNER_IDENTIFIERS);

const filterHomePageBanners = (cmsBanners: BannersQuery['allBanner'] | undefined) =>
  flow(
    filter((banner) => includes(get('identifier.current', banner), filteredValues)),
    uniqueContentWithDraftPrecedence,
  )(cmsBanners);

export default filterHomePageBanners;
